import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class TutorialService {
  private rootUrl = environment.API_URL || '';

  constructor(private httpClient: HttpClient) {}

  getTutorials(): Observable<any> {
    return this.httpClient.post(this.rootUrl + "/options/getUniversalOptions", { options: ['tutorials'] }, {});
  }

  saveTutorials(tutorials: any[]): Observable<any> {
    return this.httpClient.post(this.rootUrl + "/options/setUniversalOptions", { options: {tutorials: tutorials} }, {});
  }
}



// WEBPACK FOOTER //
// /var/www/staging.theprintlife.com/src/app/_services/tutorial.service.ts